const memberSettingsFormMixin = {
  data() {
    return {
      disableSave: true
    };
  },

  methods: {
    isOriginalValue(key, value) {
      return this.$store.getters["members/member"][key] === value;
    },
    isOriginalMemberDataValue(key, value) {
      return this.$store.getters["members/member"]["memberData"][key] === value;
    }
  }
};

export default memberSettingsFormMixin;
